export enum Category {
  Casino = 'casino',
  Slot = 'slot',
  CardGame = 'cardgame',
  Sport = 'sport',
}
